export const locale = {
  lang: 'es',
  'notifications_modal': {
    'CANCEL': 'Cancelar'
  }
};
